/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { crudDe } from "../../../../services/acesso";
import api from "../../../../services/api";
import { FaUserTie } from "react-icons/fa";
import { useEffect, useState } from "react";
import { MdDownload } from "react-icons/md";
import Listagem from "../../../../components/listagem";
import { useAppSelector } from "../../../../store/hooks";
import ModalForm from "../../../../components/modal-form";
import { IdEmpresaAdm } from "../../../../services/utilitarios";
import { TipoFormulario } from "../../../../services/constantes";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import { ApiError, Campo, Opcao, Permissao, Usuario } from "../../../../services/tipos";
import { obterEhAdmin, obterIdTenent, obterIdUsuario, usuarioTemPermissao } from "../../../../services/seguranca";
import { GerenciadorPermissoes, chavesExibidas } from "../../../../components/gerenciador-permissoes";
import { PERMISSAO_OBRIGATORIA, completarDependencias } from "../../../../services/permissoes-config";
import { useFiliais } from "../../../../hooks/useFiliais";
import TabelaComissao from "../../../../components/tabela-comissao";
import {
    obterRegrasPorUsuario,
    salvarLoteRegras,
    UsuarioComissaoRegraDto
} from "../../../../services/comissao";

function UsuarioListagem() {
    const { empresaTemFiliais, filiaisOptions } = useFiliais();
    const [filiaisDoUsuario, setFiliaisDoUsuario] = useState<any[]>([]);
    const [filiaisIniciaisDoUsuario, setFiliaisIniciaisDoUsuario] = useState<any[]>([]);
    const [filialEstrita, setFilialEstrita] = useState<boolean>(false);
    // Só true quando as filiais atuais do usuário foram REALMENTE carregadas da API. Evita que
    // uma falha/corrida no carregamento dispare uma sincronização com lista vazia e apague as
    // associações de filial do usuário.
    const [filiaisCarregadas, setFiliaisCarregadas] = useState<boolean>(false);
    const [empresas, setEmpresas] = useState<Opcao[]>([]);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [permissoes, setPermissoes] = useState<Permissao[]>([]);
    const [dependencias, setDependencias] = useState<Record<string, string[]>>({});
    const [token] = useState(useAppSelector(state => state.token));
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState<Usuario>({} as Usuario);
    const [realizarConsultasPermissoes, setRealizarConsultasPermissoes] = useState<boolean>(true);
    const [realizarConsultaEmpresas, setRealizarConsultaEmpresas] = useState<boolean>(obterIdTenent(token) == IdEmpresaAdm ? true : false);
    const [regrasComissao, setRegrasComissao] = useState<UsuarioComissaoRegraDto[]>([]);
    const [categorias, setCategorias] = useState<{ id: string; nome: string }[]>([]);
    // Frota da empresa, para as regras de comissão por locação restritas a um veículo.
    const [veiculos, setVeiculos] = useState<{ id: string; placa: string; modelo?: string }[]>([]);
    const idUsuarioLogado = obterIdUsuario(token);
    const isAdmin = obterEhAdmin(token);
    const ehPlataforma = obterIdTenent(token) == IdEmpresaAdm;
    const ehVerdadeiro = (valor: any) => valor === true || valor === 'true';

    const colunas = [
        { field: 'nome', headerName: 'Nome', flex: 1 },
        { field: 'email', headerName: 'Email', flex: 1 },
        {
            field: 'administrador', headerName: 'Administrador', flex: 1, valueGetter: (params: any) => {
                return params.value ? 'Sim' : 'Não';
            }
        },
    ];

    const pages = [
        {
            titulo: "Informações",
            campos: ["nome", "email", "senha"]
        },
        {
            titulo: "Permissões",
            // "administrador" é escolhido dentro do GerenciadorPermissoes (tipo de acesso).
            campos: ["permissoes"]
        },
        {
            titulo: "Comissão",
            campos: ["comissao"]
        },
        ...(empresaTemFiliais ? [{
            titulo: "Unidades",
            campos: ["filiais", "filialEstrita"]
        }] : []),
    ]

    const campos: Campo[] = [
        { label: 'Nome', nome: 'nome', required: true, tipo: 'text', largura: 6, coluna: 2, linha: 1, visible: true, tudoMaiusculo: true },
        { label: 'Email', nome: 'email', required: true, tipo: 'email', largura: 6, coluna: 1, linha: 2, visible: true, tudoMaiusculo: false },
        {
            label: 'Senha', nome: 'senha', required: isAdmin || modo === TipoFormulario.tpCadastro, tipo: 'senha', largura: 6, coluna: 2, linha: 2,
            visible: isAdmin || modo === TipoFormulario.tpCadastro, tudoMaiusculo: true,
        },
        {
            // Escolhido no GerenciadorPermissoes (tipo de acesso), fora de qualquer página; por isso não é obrigatório aqui.
            label: 'Administrador', nome: 'administrador', required: false, tipo: 'select', largura: 3, coluna: 2, linha: 1, visible: true, tudoMaiusculo: true,
            opcoes: [{ label: 'Sim', valor: true }, { label: 'Não', valor: false }],
            valorPadrao: false,
            // Só administrador concede ou retira acesso de administrador (a API também recusa).
            apenasLeitura: !isAdmin,
        },
        { label: 'Empresa', nome: 'idEmpresa', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 2, visible: obterIdTenent(token) == IdEmpresaAdm ? true : false, tudoMaiusculo: true, opcoes: empresas },
        {
            // Sem rótulo: a etapa já se chama Permissões.
            label: '', nome: 'permissoes', required: false, tipo: 'custom', largura: 12, coluna: 2, linha: 6, visible: true,
            component: (props: any) => (
                <GerenciadorPermissoes
                    permissoesDisponiveis={permissoes}
                    permissoesSelecionadas={props.value || []}
                    onChange={props.onChange}
                    somenteLeitura={modo === TipoFormulario.tpVisualizacao}
                    administrador={ehVerdadeiro(props.entidade?.administrador)}
                    onAdministradorChange={isAdmin && modo !== TipoFormulario.tpVisualizacao
                        ? (valor: boolean) => props.handleInputChange('administrador', valor)
                        : undefined}
                    dependencias={dependencias}
                    ehPlataforma={ehPlataforma}
                />
            )
        },
        {
            linha: 1, coluna: 1, largura: 12,
            nome: "comissao", label: "Comissão", tipo: "custom",
            required: false, visible: true,
            component: (props: any) => (
                <TabelaComissao
                    value={regrasComissao}
                    onChange={setRegrasComissao}
                    categorias={categorias}
                    veiculos={veiculos}
                    apenasLeitura={modo === TipoFormulario.tpVisualizacao || usuarioSelecionado?.id === idUsuarioLogado || !isAdmin}
                    modoVisualizacao={modo === TipoFormulario.tpVisualizacao}
                    idUsuario={usuarioSelecionado?.id ?? ""}
                    idEmpresa={obterIdTenent(token)}
                />
            )
        },
        {
            coluna: 1, label: 'Unidades', largura: 12, nome: 'filiais', tipo: 'multiselect', linha: 5, required: false,
            visible: empresaTemFiliais,
            selectMultiProps: {
                dataSource: filiaisOptions.map(f => ({ id: f.valor, nome: f.label })),
                onSelectionChange: (data: any) => setFiliaisDoUsuario(data),
                optionLabelField: 'nome',
                height: '200px',
                // Na visualização a lista de unidades também fica travada.
                modo: modo === TipoFormulario.tpVisualizacao ? TipoFormulario.tpVisualizacao : TipoFormulario.tpCadastro,
                initialSelected: filiaisIniciaisDoUsuario,
                criticarRepeticao: true,
                orderByField: "nome",
                multiValueBackground: "#1F467E",
            },
        },
        {
            coluna: 1, label: 'Unidade Estrita (ocultar registros sem unidade)', largura: 12, nome: 'filialEstrita', tipo: 'select', linha: 6, required: false,
            visible: empresaTemFiliais,
            opcoes: [{ label: 'Sim', valor: true }, { label: 'Não', valor: false }],
        }
    ];

    useEffect(() => {
        if (realizarConsultasPermissoes) {
            api.get(`/Permissao/`)
                .then(response => {
                    setPermissoes(response.data);
                    setRealizarConsultasPermissoes(false);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });

            // Sem o mapa a tela segue funcionando; a API completa as dependências ao salvar de qualquer forma.
            api.get(`/Permissao/Dependencias`)
                .then(response => setDependencias(response.data || {}))
                .catch(() => setDependencias({}));
        }
    }, [realizarConsultasPermissoes]);

    useEffect(() => {
        api.get(`/CategoriaPorEmpresa/${obterIdTenent(token)}`)
            .then(r => setCategorias(r.data))
            .catch(() => setCategorias([]));

        // Só os ativos: comissionar por um veículo que já saiu da frota só polui a lista.
        api.get(`/VeiculoPorEmpresaAtivos/${obterIdTenent(token)}`)
            .then(r => setVeiculos(Array.isArray(r.data) ? r.data : []))
            .catch(() => setVeiculos([]));
    }, [token]);

    useEffect(() => {
        if (exibirFormModal && usuarioSelecionado?.id) {
            obterRegrasPorUsuario(usuarioSelecionado.id)
                .then(r => setRegrasComissao(r.data))
                .catch(() => setRegrasComissao([]));
        } else if (!exibirFormModal) {
            setRegrasComissao([]);
        }
    }, [exibirFormModal, usuarioSelecionado]);

    const temPermissao = usuarioTemPermissao(token, 'usuario_visualizar');

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        toast.error('Não foi possível continuar a operação Usuário: ' + error.response?.data.Mensagem)
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        setRealizarConsulta(true);
    }

    const handleCadastrar = async () => {
        if (usuarioTemPermissao(token, 'usuario_novo')) {
            setModo(TipoFormulario.tpCadastro)
            setUsuarioSelecionado({} as Usuario);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar um novo Usuario');
        }
    }

    /**
     * Carrega permissões e unidades ANTES de abrir o formulário. Antes elas chegavam depois de aberto e
     * reiniciavam a entidade do formulário, apagando o que já tinha sido digitado. Se a carga falhar, o
     * formulário não abre: salvar sem as permissões atuais poderia gravar um conjunto errado.
     */
    const abrirUsuarioExistente = async (Usuario: any, novoModo: TipoFormulario) => {
        setCarregando(true);
        try {
            const [respostaPermissoes, filiais] = await Promise.all([
                api.get(`/PermissoesPorUsuario/${Usuario.id}`),
                empresaTemFiliais ? carregarFiliaisDoUsuario(Usuario.id) : Promise.resolve(null),
            ]);

            setFiliaisIniciaisDoUsuario(filiais?.lista ?? []);
            setFiliaisDoUsuario(filiais?.lista ?? []);
            setFilialEstrita(filiais?.estrita ?? false);
            // Falha nas unidades não bloqueia: só impede a sincronização no salvar (não apaga associações).
            setFiliaisCarregadas(filiais !== null);

            setModo(novoModo);
            setUsuarioSelecionado({
                ...Usuario,
                permissoes: respostaPermissoes.data,
                ...(filiais ? { filialEstrita: filiais.estrita } : {}),
            });
            setExibirFormModal(true);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    }

    const handleEditar = async (Usuario: any) => {
        if (!usuarioTemPermissao(token, 'usuario_editar')) {
            toast.error('Você não tem permissão para editar um Usuario');
            return;
        }
        if (Usuario.id && Usuario.id == idUsuarioLogado) {
            toast.error('Você não pode Editar o seu próprio usuário');
            return;
        }
        await abrirUsuarioExistente(Usuario, TipoFormulario.tpEdicao);
    }

    const handleExclusao = async (Usuario: Usuario) => {
        if (obterIdUsuario(token) == Usuario.id) {
            toast.error('Você não pode Excluir o seu próprio usuário');
            return;
        }

        if (usuarioTemPermissao(token, 'usuario_excluir')) {
            setCarregando(true);
            await api.delete(`/Usuario/${Usuario.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success('Usuario foi excluído com sucesso')
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }
    }

    const handleVisualizacao = async (Usuario: any) => {
        if (usuarioTemPermissao(token, 'usuario_visualizar')) {
            await abrirUsuarioExistente(Usuario, TipoFormulario.tpVisualizacao);
        }
    }

    useEffect(() => {
        if (obterIdTenent(token) == IdEmpresaAdm) {
            const fetchBuscarEmpresas = async () => {
                if (temPermissao && realizarConsultaEmpresas) {
                    api.get(`/Empresa/`)
                        .then(response => {
                            setTimeout(() => {
                                const novasOpcoes = response.data.map((empresa: any) => ({
                                    valor: empresa.id,
                                    label: `${empresa.documento} - ${empresa.nome}`,
                                }));

                                setEmpresas(novasOpcoes);
                                setCarregando(false);
                                setRealizarConsultaEmpresas(false);
                            }, 250);
                        }).catch((error: AxiosError<ApiError>) => {
                            tratarErro(error);
                        });
                }
            }

            fetchBuscarEmpresas();
        }
    }, [token, realizarConsultaEmpresas]);

    useEffect(() => {
        if (obterIdTenent(token) == IdEmpresaAdm) {
            const fetchUsuarioPorUsuario = async () => {
                if ((temPermissao) && (realizarConsulta)) {
                    setCarregando(true);
                    await api.get(`/Usuario/`)
                        .then(response => {
                            setTimeout(() => {
                                setUsuarios(response.data);
                                setRealizarConsulta(false);
                                setCarregando(false);
                            }, 250);
                        }).catch((error: AxiosError<ApiError>) => {
                            setCarregando(false);
                            tratarErro(error);
                        });
                }
            }

            fetchUsuarioPorUsuario();
        } else {
            const fetchUsuariosDaEmpresa = async () => {
                if ((temPermissao) && (realizarConsulta)) {
                    setCarregando(true);
                    await api.get(`/UsuarioPorEmpresa/${obterIdTenent(token)}`)
                        .then(response => {
                            setTimeout(() => {
                                setUsuarios(response.data);
                                setRealizarConsulta(false);
                                setCarregando(false);
                            }, 250);
                        }).catch((error: AxiosError<ApiError>) => {
                            setCarregando(false);
                            tratarErro(error);
                        });
                }
            }

            fetchUsuariosDaEmpresa();
        }
    }, [temPermissao, realizarConsulta, token]);

    const requisicaoBemSucedida = (response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success('Usuario salvo com sucesso')
        setCarregando(false);
    }

    const onShow = () => {
        // Usuário existente já chega com permissões e unidades carregadas (abrirUsuarioExistente).
        if (modo == TipoFormulario.tpCadastro) {
            setFiliaisDoUsuario([]);
            setFiliaisIniciaisDoUsuario([]);
            setFilialEstrita(false);
            setFiliaisCarregadas(false);
        }
    }

    /** Unidades atuais do usuário; null quando a carga falha (a sincronização no salvar é pulada). */
    const carregarFiliaisDoUsuario = async (idUsuario: string): Promise<{ lista: any[]; estrita: boolean } | null> => {
        try {
            const response = await api.get(`/Filial/PorUsuarioDetalhado/${idUsuario}`);
            const dados = response.data || [];
            return {
                lista: dados.map((f: any) => ({ id: f.idFilial || f.id, nome: f.nomeFilial || f.nome })),
                // Se qualquer associação tem filialEstrita, marca como true
                estrita: dados.some((f: any) => f.filialEstrita === true),
            };
        } catch (error: any) {
            return null;
        }
    }

    /**
     * Conjunto final a gravar: o que foi escolhido, tudo o que a tela exibe quando é administrador, as
     * dependências de cada tela e a permissão obrigatória. Nada do que o usuário já tinha é descartado.
     */
    const montarPermissoesParaSalvar = (entidade: any): Permissao[] => {
        const escolhidas: Permissao[] = Array.isArray(entidade['permissoes']) ? entidade['permissoes'] : [];
        const chaves = new Set(escolhidas.map(p => p.chave));
        if (ehVerdadeiro(entidade['administrador'])) {
            chavesExibidas(permissoes, ehPlataforma).forEach(c => chaves.add(c));
        }
        chaves.add(PERMISSAO_OBRIGATORIA);

        const porChave = new Map(permissoes.map(p => [p.chave, p]));
        const originais = new Map(escolhidas.map(p => [p.chave, p]));
        return Array.from(completarDependencias(chaves, dependencias))
            .map(c => porChave.get(c) ?? originais.get(c))
            .filter((p): p is Permissao => !!p);
    }

    const sincronizarFiliaisDoUsuario = async (idUsuario: string, entidade?: any) => {
        // No cadastro (usuário novo) não há nada a carregar — a seleção do form é a fonte da verdade.
        // Na edição, só sincroniza se as filiais atuais foram carregadas com sucesso (filiaisCarregadas),
        // evitando que uma lista vazia por falha/corrida de carregamento apague as associações.
        const ehCadastro = modo == TipoFormulario.tpCadastro;
        if (empresaTemFiliais && (ehCadastro || filiaisCarregadas)) {
            try {
                const estrita = entidade?.filialEstrita === true || entidade?.filialEstrita === 'true';
                await api.post('/Filial/SincronizarFiliaisUsuario', {
                    idUsuario: idUsuario,
                    idFiliais: filiaisDoUsuario.map((f: any) => f.id),
                    filialEstrita: estrita,
                });
            } catch (error: any) {
                // Log but don't block save
                console.error('Erro ao sincronizar filiais do usuário:', error);
            }
        }
    }

    const onSave = async (entidade: any) => {
        if (usuarioTemPermissao(token, 'usuario_novo') || usuarioTemPermissao(token, 'usuario_editar')) {
            if (permissoes.length === 0) {
                toast.error('As permissões ainda estão carregando. Tente novamente em instantes.');
                return;
            }
            const permissoesASalvar = montarPermissoesParaSalvar(entidade);
            if (!permissoesASalvar.some(p => p.chave !== PERMISSAO_OBRIGATORIA)) {
                toast.error('Escolha o acesso a pelo menos um módulo na etapa Permissões.');
                return;
            }

            setCarregando(true);
            const usuarioASalvar: Usuario = {
                administrador: ehVerdadeiro(entidade['administrador']),
                email: entidade['email'],
                idEmpresa: obterIdTenent(token),
                nome: entidade['nome'],
                senha: entidade['senha'],
                permissoes: permissoesASalvar,
                idExpo: entidade['idExpo']
            }

            if (modo == TipoFormulario.tpEdicao) {
                usuarioASalvar['id'] = entidade['id'];
            }

            const apiAcao = modo == TipoFormulario.tpCadastro ? api.post : api.put;

            apiAcao('/Usuario/', usuarioASalvar, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(async (response) => {
                const userId = response.data?.id || entidade['id'];
                if (empresaTemFiliais && userId) {
                    await sincronizarFiliaisDoUsuario(userId, entidade);
                }
                if (isAdmin && userId && userId !== idUsuarioLogado) {
                    try {
                        await salvarLoteRegras(userId, regrasComissao);
                    } catch (err) {
                        console.error("Erro ao salvar comissoes:", err);
                        // não bloqueia fluxo de sucesso do usuário
                    }
                }
                setTimeout(() => {
                    requisicaoBemSucedida(response);
                }, 250);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
        }
    }

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('usuario')}
                    colunas={colunas}
                    linhas={usuarios}
                    nomeEntidade="Usuario"
                    nomePropriedade="nome"
                    carregando={carregando}
                    IconeEntidade={FaUserTie}
                    exibirAcoesDeCrud={true}
                    handleEditar={handleEditar}
                    handleCriar={handleCadastrar}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setUsuarioSelecionado} />

                <ModalForm
                    modo={modo}
                    tamanho="xl"
                    corpoAlto
                    campos={campos}
                    show={exibirFormModal}
                    carregando={carregando}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    entidadeSelecionada={usuarioSelecionado}
                    pages={pages}
                    onSave={onSave}
                    onShow={onShow}
                    apiConfig={
                        {
                            endpoint: "Usuario",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idUsuario'
                        }
                    }
                />
            </LocaSmartLayout>
        </>
    );
}

export default UsuarioListagem;